import React, { useLayoutEffect, useState } from 'react';
import { useEffectOnce } from 'react-use';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { Wrapper } from './ClientSearch.styles';
import { ClientCombobox } from './components/ClientCombobox/ClientCombobox';
import { queryKeys } from './api/queryKeys';
import {
  adviserFirstNameSelector as selectAdvisorFirstName,
  shouldShowStartPageSelector as selectShowStartPage,
  showClientsList as selectShowClientList,
} from '../AdviserArea/AdviserAreaSelector';
import { Navigation } from './components/Navigation/Navigation';
import { ClientList } from './components/ClientList/ClientList';
import { fetchClientList } from './api/useClientListQuery';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';

export const ClientSearch = () => {
  const [isClientListOpen, setIsClientListOpen] = useState(false);

  const queryClient = useQueryClient();

  const adviserFirstName = useSelector(selectAdvisorFirstName);
  const showClientList = useSelector(selectShowClientList);
  const showStartPage = useSelector(selectShowStartPage);

  useDocumentTitle();

  useLayoutEffect(() => {
    if (showStartPage) {
      ADV.util.Router.go2('GetStarted');
    }
  }, [showStartPage]);

  useEffectOnce(() => {
    queryClient.prefetchInfiniteQuery(queryKeys.clientList(), () => fetchClientList());

    return () => {
      queryClient.removeQueries(queryKeys.clientListAll());
    };
  });

  return (
    <>
      <Wrapper as="main">
        <Text as="h1" fontSize="h2" fontWeight={500} color="neutral.900" mb="12">
          Welcome {adviserFirstName}
        </Text>

        <Box width="100%" maxWidth={600} mx="auto" mb="24">
          <ClientCombobox size="large" />
        </Box>

        <Navigation onClientListClick={() => setIsClientListOpen(true)} />
      </Wrapper>

      {showClientList && isClientListOpen && (
        <ClientList onClose={() => setIsClientListOpen(false)} />
      )}
    </>
  );
};
